<template>
  <a class="drawer-btn" @click="open = !open">
    <p>
      <svg
        width="24px"
        height="22px"
        viewBox="0 0 24 22"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
      >
        <g
          id="Symbols"
          stroke="none"
          stroke-width="1"
          fill="none"
          fill-rule="evenodd"
        >
          <g
            id="Icons/shoppingBag"
            transform="translate(-1.000000, -2.000000)"
            stroke="#5C5C5C"
          >
            <g id="Group-5" transform="translate(2.000000, 3.000000)">
              <polygon
                id="Stroke-1"
                points="4.07415036 20 18.0542396 20 22 6 0 6"
              ></polygon>
              <path
                d="M17,5.92795156 C17,5.92795156 16.165625,0 11.1587054,0 C6.15245536,0 5,6 5,6"
                id="Stroke-3"
              ></path>
            </g>
          </g>
        </g>
      </svg>
      <span class="count">{{ data.item_count }}</span>
    </p>
  </a>
</template>

<script>
export default {
  computed: {
    data() {
      return this.$store.getters["cart/data"];
    },
    open: {
      get() {
        return this.$store.getters["cart/open"];
      },
      set(open) {
        this.$store.commit("cart/open", open);
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.drawer-btn {
  position: relative;
  margin: 0 !important ;
  span.count {
    color: $white;
    font-size: 9px;
    width: 12px;
    height: 12px;
    background-color: $brown;
    position: absolute;
    border-radius: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    top: 0;
    right: -5px;
  }
}
</style>
